<template>
<div class="m-content">
        <MenuViews></MenuViews>

        <div class="m-portlet m-portlet--mobile">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">{{ labels.view_related_incis | capitalize }} {{ hits.length ? `(${ hits.length } ${labels.products})` : '' }}</h3>
        </div>
      </div>

      <div class="m-portlet__head-tools">
        <ul class="m-portlet__nav">
          <li class="m-portlet__nav-item">
              <button
                @click="exportExcel()"
                type="button"
                class="btn btn-elevate btn-icon-sm btn-pill"
              >
                <i class="la la-download"></i>
                {{ labels.export | capitalize }}
              </button>
          </li>
          <li class="m-portlet__nav-item">
              <button
                tag="button"
                @click="$router.go(-1)"
                class="btn btn-elevate btn-icon-sm btn-pill">{{ labels.return }}</button>
            </li>
        </ul>
      </div>
    </div>
    <div class="m-portlet__body">
        <TableWithFilter
          :rawData="rawData"
          :fields="fields"
          :viewlabels="labels.exportRelatedIncisView"
          :facetFilters="searchParameters ? searchParameters.facetFilters : []"
        ></TableWithFilter>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import * as algoliasearch from 'algoliasearch';
import TableWithFilter from '../../Table/TableWithFilter.vue';
import MenuViews from '../MenuViews.vue';
import exportRelatedIncisView from '../../../assets/js/exportRelatedIncisView';

const client = algoliasearch(
  process.env.ALGOLIA_APP_ID,
  process.env.ALGOLIA_SEARCH_KEY,
);
const productIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_products`);

export default {
  name: 'RelatedIncisTable',
  components: {
    TableWithFilter,
    MenuViews,
  },
  data() {
    return {
      hits: [],
      rawData: null,
      relatedIncisStats: {},
      query: '',
      searchParameters: null,
      browseObject: null,
      fields: [
        {
          id: 'relatedIncis',
          orderable: true,
          searchType: 'text',
          filterName: 'relatedIncis',
          orderData: [0],
          facetFilters: 'ingredientsV2.related_inci',
        },
        {
          id: 'numberInProduct',
          orderable: true,
          searchType: false,
          filterName: 'segmentationParents',
          orderData: [1, 0],
          width: '100px',
        },
        {
          id: 'percentageShow',
          orderable: true,
          searchType: false,
          filterName: 'percentageShow',
          orderData: [2, 0],
          width: '100px',
        },
        {
          id: 'ingredients',
          orderable: false,
          searchType: 'text',
          filterName: 'ingredients',
          facetFilters: 'ingredientsMix.name',
        },
        {
          id: 'numberInPatent',
          orderable: true,
          searchType: false,
          filterName: 'numberInPatent',
          orderData: [4, 0],
          width: '100px',
        },
        {
          id: 'roles',
          orderable: false,
          searchType: 'text',
          filterName: 'roles',
          facetFilters: 'rolesMix.name',
        },
        {
          id: 'claimed',
          orderable: true,
          searchType: false,
          filterName: 'claimed',
          orderData: [6, 0],
          width: '100px',
        },
        {
          id: 'themes',
          orderable: false,
          searchType: 'text',
          filterName: 'themes',
          facetFilters: 'themes',
        },
        {
          id: 'parentSegmentations',
          orderable: false,
          searchType: 'text',
          filterName: 'parentSegmentations',
          facetFilters: 'parentSegmentation',
        },
        {
          id: 'subSegmentations',
          orderable: false,
          searchType: 'text',
          filterName: 'subSegmentations',
          facetFilters: 'subSegmentation',
          width: '700px',
        },
      ],
    };
  },
  mixins: [exportRelatedIncisView],
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      selectedProductIds: (store) => store.products.selectedProductIds,
      allSelected: (store) => store.products.allSelected,
      lastSearch: (store) => store.products.lastSearch,
      previewURL: (store) => store.products.previewURL,
    }),
  },
  methods: {
    run() {
      this.hits = [];
      this.relatedIncisStats = [];
      this.browse();
    },
    initBrowseObject() {
      let myfacetFilters = [];
      if (this.searchParameters.facetFilters) {
        myfacetFilters = [...this.searchParameters.facetFilters];
      }
      myfacetFilters.push(['hasClaims:true', 'hasClaims:false']);
      // const restrictSearchableAttributes = JSON.parse(
      //   this.searchParameters.restrictSearchableAttributes,
      // );
      const restrictSearchableAttributes = '';

      this.browseObject = {
        facetFilters: myfacetFilters,
        restrictSearchableAttributes,
      };
    },
    browse() {
      const browser = productIndex.browseAll(
        this.query,
        this.browseObject,
      );
      const my = this;
      browser.on('result', (content) => {
        my.hits = my.hits.concat(content.hits);
      });

      browser.on('end', () => {
        console.log('We got %d hits', my.hits.length);
        this.startStats();
        this.rawData = this.transformObjectToArrayV2(this.relatedIncisStats);
      });

      browser.on('error', (err) => {
        throw err;
      });
    },
    startStats() {
      const my = this;
      this.hits.forEach((hit) => {
        const relatedIncisInThisHit = [];
        const currentRelatedIncisInProduct = [];

        // ingredients inside product
        if (hit.ingredientsV2) {
          hit.ingredientsV2.forEach((ingredient) => {
            if (ingredient.related_inci !== null) {
              this.addRelatedInciIfNotYet(ingredient.related_inci);

              // check if we didn't count this ingredient already for this product
              if (currentRelatedIncisInProduct.indexOf(ingredient.related_inci) === -1) {
                currentRelatedIncisInProduct.push(ingredient.related_inci);
                if (ingredient.claimed) {
                  my.relatedIncisStats[ingredient.related_inci].claimed += 1;
                }
              }

              this.generalStatPerHit(relatedIncisInThisHit, ingredient.related_inci, hit);
              this.updatePercentage(ingredient.related_inci);

              this.relatedIncisStats[ingredient.related_inci].roles = this.addRelatedIncisStats(
                this.relatedIncisStats[ingredient.related_inci].roles,
                [ingredient.roles.map((role) => role.name)],
              );
              this.relatedIncisStats[ingredient.related_inci].ingredients = this.addRelatedIncisStats(
                this.relatedIncisStats[ingredient.related_inci].ingredients,
                [ingredient.name],
              );
            }
          });
        }

        // ingredient inside patent
        if (hit.patentsV2) {
          const currentRelatedInciInPatent = [];
          hit.patentsV2.forEach((patent) => {
            patent.ingredients.forEach((ingredient) => {
              if (ingredient.related_inci !== null) {
                this.addRelatedInciIfNotYet(ingredient.related_inci);
                // check if we didn't count this ingredient already for this product (in other patent)
                if (currentRelatedInciInPatent.indexOf(ingredient.related_inci) === -1) {
                  currentRelatedInciInPatent.push(ingredient.related_inci);
                  my.relatedIncisStats[ingredient.related_inci].numberInPatent += 1;
                }
                this.relatedIncisStats[ingredient.related_inci].ingredients = this.addRelatedIncisStats(
                  this.relatedIncisStats[ingredient.related_inci].ingredients,
                  [ingredient.name],
                );

                this.generalStatPerHit(relatedIncisInThisHit, ingredient.related_inci, hit);
                this.updatePercentage(ingredient.related_inci);
              }
            });
          });
        }
      });
    },
    updatePercentage(relatedInci) {
      // actualise the percentage
      this.relatedIncisStats[relatedInci].percentageShow = this.relatedIncisStats[relatedInci].numberInProduct
        ? this.relatedIncisStats[relatedInci].numberInProduct
                / this.hits.length
        : 0;
    },
    addRelatedInciIfNotYet(relatedInci) {
      if (!Object.prototype.hasOwnProperty.call(this.relatedIncisStats, relatedInci)) {
        this.relatedIncisStats[relatedInci] = {
          name: relatedInci,
          numberInProduct: 0,
          numberInPatent: 0,
          percentageShow: 0,
          roles: [],
          ingredients: [],
          themes: [],
          parentSegmentations: [],
          subSegmentations: [],
          claimed: 0,
        };
      }
    },
    addRelatedIncisStats(elemStats, elems) {
      const stats = elemStats;
      if (elems) {
        const temp = [];
        elems.forEach((elem) => {
          if (elem !== null && temp.indexOf(elem) === -1) {
            temp.push(elem);
            if (
              !Object.prototype.hasOwnProperty.call(stats, elem)
            ) {
              stats[elem] = 0;
            }
            stats[elem] += 1;
          }
        });
      }

      return stats;
    },
    generalStatPerHit(relatedIncisInThisHit, relatedInci, hit) {
      if (relatedIncisInThisHit.indexOf(relatedInci) === -1) {
        relatedIncisInThisHit.push(relatedInci);
        this.relatedIncisStats[relatedInci].numberInProduct += 1;
        this.relatedIncisStats[relatedInci].themes = this.addRelatedIncisStats(
          this.relatedIncisStats[relatedInci].themes,
          hit.themes,
        );
        this.relatedIncisStats[relatedInci].parentSegmentations = this.addRelatedIncisStats(
          this.relatedIncisStats[relatedInci].parentSegmentations,
          hit.parentSegmentation,
        );
        this.relatedIncisStats[relatedInci].subSegmentations = this.addRelatedIncisStats(
          this.relatedIncisStats[relatedInci].subSegmentations,
          hit.subSegmentation,
        );
      }
    },
    exportExcel() {
      this.exportRelatedIncisView(this.relatedIncisStats, this.hits.length);
    },
    createParams(params) {
      try {
        const searchParameters = {
          attributesToRetrieve: ['productId'],
        };
        params.forEach((param) => {
          const splitParam = param.split('=');
          const key = decodeURIComponent(splitParam[0]);
          const value = decodeURIComponent(splitParam[1]);

          if (key === 'hitsPerPage') {
            searchParameters[key] = 1000;
          } else if (key === 'page') {
            searchParameters[key] = 0;
          } else {
            searchParameters[key] = value;
          }
        });
        searchParameters.facetFilters = (searchParameters.facetFilters) ? JSON.parse(searchParameters.facetFilters) : [];

        return searchParameters;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    setSearchParameter() {
      if (this.previewURL.length) {
        // Get the last result object
        const lastResult = this.previewURL[0];
        if (lastResult) {
          this.query = lastResult.query;

          const queryArray = lastResult.params.split('&');
          this.searchParameters = this.createParams(queryArray, 0);
        }
      }
    },
    goToIngredientsView() {
      this.$router.push({ name: 'IngredientsTable' });
    },
    goToRolesView() {
      this.$router.push({ name: 'RolesTable' });
    },
    goToRelatedIncisView() {
      this.$router.push({ name: 'RelatedIncisTable' });
    },
  },
  mounted() {
    this.setSearchParameter();
    this.initBrowseObject();
    this.run();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Products/RelatedIncis/RelatedIncisTable.vue